import React, { Component } from 'react';
import ChartDisplay from "./components/chartDisplay.js"
import moment from 'moment';

import TorGrid from './../torgrid/torgrid';

class PortfolioOverview extends Component {
    constructor(props) {
        super(props);
        this.state = {
            chartData: []
        }

        this.filterChartData = this.filterChartData.bind(this);

        this.isZero = this.isZero.bind(this);
        this.getDate = this.getDate.bind(this);
        this.agValueFormatter = this.agValueFormatter.bind(this);
        this.getValueFormatted = this.getValueFormatted.bind(this);
        this.getData = this.getData.bind(this);
        this.getBucketChartConfig = this.getBucketChartConfig.bind(this);
        this.sortBucketKeys = this.sortBucketKeys.bind(this);
        this.normalizeBucketLabel = this.normalizeBucketLabel.bind(this);
        this.renderBucketStackedChart = this.renderBucketStackedChart.bind(this);
        this.parseNumericValue = this.parseNumericValue.bind(this);
        this.getAssetMarketValue = this.getAssetMarketValue.bind(this);
        this.getDerivedMaturityBucket = this.getDerivedMaturityBucket.bind(this);
        this.getDerivedVintageYear = this.getDerivedVintageYear.bind(this);
    }


    render() {
        return this.getTemplate();
    }

    isZero(value) {
        return value < 0.0001 && value > -0.0001
    }

    getDate(params) {
        var val = Date(params.value);
        return val;
    }

    agValueFormatter(value, format) {
        var agformat = format;
        if (value && value !== '' && value !== 0) {
            switch (agformat) {
                case 'millionsFormat':
                    return this.getValueFormatted(value / 1e6, 1);
                case 'millionsFormat2':
                    return this.getValueFormatted(value / 1e6, 2);
                case 'percentFormat':
                    return this.getValueFormatted(value * 100);
                case 'percentFormat1':
                    return this.getValueFormatted(value * 100, 1);
                case 'decimalFormat0':
                    return this.getValueFormatted(value, 0);
                case 'decimalFormat2':
                    return this.getValueFormatted(value, 2);
                case '{0:.2f}x':
                    return this.getValueFormatted(value);
                case 'leverageFormat':
                    const displayvalue = this.getValueFormatted(value, 2);
                    return `${displayvalue}${displayvalue && displayvalue.toString() !== '' ? 'x' : ''}`;
                case 'dateFormat':
                    return this.getDate(value);
                default:
                    return value;
            }
        }
        else if (value && value !== '' && agformat === 'decimalFormatShowZero2')
            return this.getValueFormatted(value, 2);
        return '';
    }

    getValueFormatted(param, digit = 2) {
        var result = param;
        var val = 0.0;

        if (!isNaN(result)) {
            try {
                val = parseFloat(result).toFixed(digit);
                if (this.isZero(val)) return '';

                if (!isNaN(val))
                    result = val.toString()
                        .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
            } catch (error) {
                val = result;
            }
        }
        return result;
    }

    getData() {
        var grossMV = 0.0;
        var capital = 0.0;
        var cYield = 0.0;

        var data = this.props.gridData

        for (var i = 0; i < data.length; i++) {
            grossMV += data[i]['asset mv'];
            capital += data[i]['capital total'];
            cYield += (data[i]['gross annual total coupon'] + data[i]['gross annual fx carry'] + data[i]['annual cost of capital'])
        }

        return [grossMV, capital, grossMV / capital, cYield / capital];
    }

    filterChartData(colName, value, freq) {
        var data = this.props.chartData;
        var AsOfDate = moment(this.props.AsOfDate).format("YYYYMMDD");

        data = data.filter(function (item) {
            return item['for frequency'] === freq
        });

        data = data.filter(function (item) {
            return item['report date']  <= AsOfDate
        });

        if (value !== 'All') {
            var arr = data.filter(function (item) {
                return item[colName] === value
            });

            this.setState({
                chartData: arr
            });
        } else {
            this.setState({
                chartData: data
            });
        }
    }

    componentDidMount() {
        if (this.props.fund && this.props.chartData) {
            this.setState({
                chartData: []
            }, () => {
                this.filterChartData('fund', this.props.fund, this.props.Frequency)
            });
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.fund !== this.props.fund || prevProps.AsOfDate !== this.props.AsOfDate || prevProps.chartData !== this.props.chartData) {
            this.filterChartData('fund', this.props.fund, this.props.Frequency)
        }
    }

    getRankedExposureRows(valueKey, sortDirection) {
        const totalsByDeal = (this.props.gridData ?? []).reduce((totals, row) => {
            const deal = row?.deal;
            const value = Number(row?.[valueKey]);

            if (!deal || !Number.isFinite(value) || value === 0) {
                return totals;
            }

            totals[deal] = (totals[deal] ?? 0) + value;
            return totals;
        }, {});

        return Object.keys(totalsByDeal)
            .map(deal => ({ deal: deal, value: totalsByDeal[deal] }))
            .sort((left, right) => sortDirection === 'asc' ? left.value - right.value : right.value - left.value)
            .slice(0, 10);
    }

    normalizeBucketLabel(value) {
        if (value === null || typeof value === 'undefined') {
            return 'Uncategorized';
        }

        const text = String(value).trim();
        return text.length > 0 ? text : 'Uncategorized';
    }

    parseNumericValue(value) {
        if (typeof value === 'number') {
            return Number.isFinite(value) ? value : null;
        }

        const text = String(value ?? '').trim();
        if (text.length === 0) {
            return null;
        }

        const isNegativeByParentheses = /^\(.*\)$/.test(text);
        const normalizedText = text
            .replace(/^\((.*)\)$/, '$1')
            .replace(/[$,%\s]/g, '')
            .replace(/,/g, '');
        const normalized = Number(normalizedText);
        if (!Number.isFinite(normalized)) {
            return null;
        }

        if (isNegativeByParentheses) {
            return -Math.abs(normalized);
        }

        return Number.isFinite(normalized) ? normalized : null;
    }

    getAssetMarketValue(row) {
        const valueColumns = [
            'asset mv',
            'asset mv clean',
            'credit or financing mv clean',
            'credit mv clean',
            'mv total'
        ];

        for (let i = 0; i < valueColumns.length; i++) {
            const parsed = this.parseNumericValue(row?.[valueColumns[i]]);
            if (parsed !== null) {
                return parsed;
            }
        }

        return null;
    }

    getDerivedMaturityBucket(row) {
        const existing = this.normalizeBucketLabel(row?.['maturity bucket']);
        if (existing !== 'Uncategorized') {
            return existing;
        }

        const yearsToMaturity = this.parseNumericValue(row?.['years to maturity']);
        if (yearsToMaturity !== null) {
            if (yearsToMaturity < 0) return 'Expired';
            if (yearsToMaturity < 1) return '0-1 yrs';
            if (yearsToMaturity < 2) return '1-2 yrs';
            if (yearsToMaturity < 3) return '2-3 yrs';
            if (yearsToMaturity < 4) return '3-4 yrs';
            if (yearsToMaturity < 5) return '4-5 yrs';
            return '5+ yrs';
        }

        const maturityDate = moment(row?.['maturity date'], ['YYYY-MM-DD', 'YYYYMMDD', 'MM/DD/YYYY', 'DD/MM/YYYY'], true);
        const asOfDate = moment(this.props.AsOfDate, ['YYYY-MM-DD', 'YYYYMMDD'], true);
        if (maturityDate.isValid() && asOfDate.isValid()) {
            const years = maturityDate.diff(asOfDate, 'days') / 365.25;
            if (years < 0) return 'Expired';
            if (years < 1) return '0-1 yrs';
            if (years < 2) return '1-2 yrs';
            if (years < 3) return '2-3 yrs';
            if (years < 4) return '3-4 yrs';
            if (years < 5) return '4-5 yrs';
            return '5+ yrs';
        }

        return 'Uncategorized';
    }

    getDerivedVintageYear(row) {
        const existing = this.normalizeBucketLabel(row?.['vintage year']);
        if (existing !== 'Uncategorized') {
            return existing;
        }

        const vintageQuarter = this.normalizeBucketLabel(row?.['vintage quarter']);
        if (vintageQuarter !== 'Uncategorized') {
            const yearMatch = String(vintageQuarter).match(/(19|20)\d{2}/);
            if (yearMatch) {
                return yearMatch[0];
            }
        }

        const reportDate = String(row?.['report date'] ?? '').trim();
        if (/^\d{8}$/.test(reportDate)) {
            return reportDate.substring(0, 4);
        }
        if (/^(19|20)\d{2}-\d{2}-\d{2}$/.test(reportDate)) {
            return reportDate.substring(0, 4);
        }

        return 'Uncategorized';
    }

    sortBucketKeys(bucketKey, bucketKeys) {
        const uncategorized = 'Uncategorized';

        if (bucketKey === 'vintage year') {
            return [...bucketKeys].sort((left, right) => {
                if (left === uncategorized) return 1;
                if (right === uncategorized) return -1;

                const leftNumber = Number(left);
                const rightNumber = Number(right);
                const hasLeftNumber = Number.isFinite(leftNumber);
                const hasRightNumber = Number.isFinite(rightNumber);

                if (hasLeftNumber && hasRightNumber) {
                    return leftNumber - rightNumber;
                }

                return String(left).localeCompare(String(right), undefined, { numeric: true, sensitivity: 'base' });
            });
        }

        return [...bucketKeys].sort((left, right) => {
            if (left === uncategorized) return 1;
            if (right === uncategorized) return -1;
            return String(left).localeCompare(String(right), undefined, { numeric: true, sensitivity: 'base' });
        });
    }

    getBucketChartConfig(bucketKey) {
        const seriesKey = this.props.GroupBy;
        const rows = this.props.gridData ?? [];

        if (!seriesKey || rows.length === 0) {
            return { data: [], series: [], xKey: 'bucket' };
        }

        const buckets = new Map();
        const labels = new Set();

        rows.forEach((row) => {
            const bucket = bucketKey === 'maturity bucket'
                ? this.getDerivedMaturityBucket(row)
                : bucketKey === 'vintage year'
                    ? this.getDerivedVintageYear(row)
                    : this.normalizeBucketLabel(row?.[bucketKey]);
            const label = this.normalizeBucketLabel(row?.[seriesKey]);
            const value = this.getAssetMarketValue(row);

            if (value === null) {
                return;
            }

            const bucketData = buckets.get(bucket) ?? { bucket: bucket };
            bucketData[label] = (bucketData[label] ?? 0) + value;
            buckets.set(bucket, bucketData);
            labels.add(label);
        });

        const orderedLabels = [...labels].sort((left, right) => String(left).localeCompare(String(right), undefined, { numeric: true, sensitivity: 'base' }));
        const orderedBuckets = this.sortBucketKeys(bucketKey, [...buckets.keys()]);
        const limitedBuckets = bucketKey === 'vintage year'
            ? (() => {
                const numericBuckets = orderedBuckets.filter((bucket) => /^\d{4}$/.test(String(bucket)));
                if (numericBuckets.length > 0) {
                    return numericBuckets.slice(-10);
                }
                return orderedBuckets.slice(-10);
            })()
            : orderedBuckets;
        const series = orderedLabels.map((label, index) => ({ label: label, key: `series_${index}` }));
        const seriesKeyMap = new Map(series.map((entry) => [entry.label, entry.key]));

        const data = limitedBuckets.map((bucket) => {
            const source = buckets.get(bucket) ?? {};
            const next = { bucket: bucket };

            orderedLabels.forEach((label) => {
                const value = source[label];
                const key = seriesKeyMap.get(label);
                next[key] = Number.isFinite(value) ? value : 0;
            });

            return next;
        });

        return { data: data, series: series, xKey: 'bucket' };
    }

    renderBucketStackedChart(bucketKey, chartConfig) {
        const data = chartConfig?.data ?? [];
        const series = chartConfig?.series ?? [];
        const xAxisKey = chartConfig?.xKey ?? 'bucket';

        if (data.length === 0 || series.length === 0) {
            return (
                <div style={{ color: '#5f6f86', fontSize: '12px', padding: '8px' }}>
                    {`No data for ${bucketKey}`}
                </div>
            );
        }

        const yKeys = series.map((entry) => entry.key);
        const yNames = series.map((entry) => entry.label);

        return (
            <ChartDisplay
                chartTitle=""
                chartType="bar-stacked-prepared"
                xKey={xAxisKey}
                yKeys={yKeys}
                yNames={yNames}
                dataList={data}
                borderless={true}
                corporate={true}
            />
        );
    }


    getTemplate() {
        if (!this.props.GroupBy || this.props.gridData.length === 0) {
            return null;
        }

        const metrics = this.getData();
        const groupBy = this.props.GroupBy || '';
        const topGrossExposures = this.getRankedExposureRows('asset mv', 'desc');
        const topTrsExposures = this.getRankedExposureRows('deal trs mv', 'asc');
        const maturityChart = this.getBucketChartConfig('maturity bucket');
        const vintageChart = this.getBucketChartConfig('vintage year');

        return (
            <div className="portfolio-overview">
                <header className="portfolio-overview-heading">
                    <div>
                        <span className="portfolio-overview-eyebrow">Portfolio snapshot</span>
                        <h2>Portfolio Overview</h2>
                    </div>
                    <span className="portfolio-overview-badge">{`${this.props.fund === 'All' ? 'All funds' : this.props.fund} · ${moment(this.props.AsOfDate).format('MMM D, YYYY')}`}</span>
                </header>

                <section className="portfolio-overview-kpis">
                    <article className="portfolio-kpi-card">
                        <span>Gross MV</span>
                        <strong>{`$${this.agValueFormatter(metrics[0], 'millionsFormat')}M`}</strong>
                    </article>
                    <article className="portfolio-kpi-card">
                        <span>Capital</span>
                        <strong>{`$${this.agValueFormatter(metrics[1], 'millionsFormat')}M`}</strong>
                    </article>
                    <article className="portfolio-kpi-card">
                        <span>Leverage</span>
                        <strong>{this.agValueFormatter(metrics[2], 'leverageFormat')}</strong>
                    </article>
                    <article className="portfolio-kpi-card">
                        <span>Current Yield</span>
                        <strong>{`${this.agValueFormatter(metrics[3], 'percentFormat1')}%`}</strong>
                    </article>
                </section>

                <section className="portfolio-overview-section">
                    <header className="portfolio-overview-section-header">
                        <div>
                            <h3>{`Gross Asset MV by ${this.props.GroupByName}`}</h3>
                        </div>
                    </header>
                    <div className="portfolio-chart-grid">
                        <article className="portfolio-chart-card">
                            <header><h4>Current Allocation</h4></header>
                            <div className="portfolio-chart-canvas">
                                <ChartDisplay chartTitle="" chartType="pie" labelKey={groupBy} angleKey="asset mv" dataList={this.props.gridData} borderless={true} corporate={true} />
                            </div>
                        </article>
                        <article className="portfolio-chart-card">
                            <header><h4>Historical Asset MV</h4></header>
                            <div className="portfolio-chart-canvas">
                                <ChartDisplay chartTitle="" chartType="area-mln" GroupBy={groupBy} xKey="format report date" yKeys="asset mv" dataList={this.state.chartData} rotationAngle={335} corporate={true} />
                            </div>
                        </article>
                        <article className="portfolio-chart-card">
                            <header><h4>Historical Mix</h4></header>
                            <div className="portfolio-chart-canvas">
                                <ChartDisplay chartTitle="" chartType="area-normalized" GroupBy={groupBy} xKey="format report date" yKeys="asset mv" dataList={this.state.chartData} rotationAngle={335} corporate={true} />
                            </div>
                        </article>
                    </div>
                </section>

                <section className="portfolio-overview-section">
                    <header className="portfolio-overview-section-header">
                        <div>
                            <h3>Leverage and Asset Profile</h3>
                        </div>
                    </header>
                    <div className="portfolio-chart-grid portfolio-structure-chart-grid">
                        <article className="portfolio-chart-card">
                            <header><h4>Historical Leverage</h4></header>
                            <div className="portfolio-chart-canvas">
                                <ChartDisplay chartTitle="" chartType="line-grouped-alt" xKey="format report date" fund={this.props.fund} sumKeys={['asset mv', 'mv total']} yName="Leverage" dataList={this.state.chartData} rotationAngle={335} corporate={true} />
                            </div>
                        </article>
                        <article className="portfolio-chart-card">
                            <header><h4>Asset MV by Maturity</h4></header>
                            <div className="portfolio-chart-canvas">
                                {this.renderBucketStackedChart('maturity bucket', maturityChart)}
                            </div>
                        </article>
                        <article className="portfolio-chart-card">
                            <header><h4>Asset MV by Vintage</h4></header>
                            <div className="portfolio-chart-canvas">
                                {this.renderBucketStackedChart('vintage year', vintageChart)}
                            </div>
                        </article>
                    </div>
                </section>

                <section className="portfolio-overview-section portfolio-overview-table-section">
                    <header className="portfolio-overview-section-header">
                        <div>
                            <h3>Portfolio Summary</h3>
                        </div>
                    </header>
                    <div className="portfolio-overview-grid-shell">
                        <TorGrid
                            guikey="portfolioOverviewSummary"
                            isHideDateInputs={true}
                            isHideSaveGridLayout={true}
                            rowData={this.props.gridData}
                            gridIdentityColumn="position_id"
                            groupIncludeFooter={true}
                            groupIncludeTotalFooter={true}
                            marryChildren={true}
                            suppressExpandablePivotGroups={true}
                            className="dashboardgrid portfolio-overview-summary-grid"
                            rowGroupPanelShow="none"
                            enableFilter={false}
                            groupColumns={[groupBy, 'deal']}
                            domLayout="autoHeight"
                            defaultColDef={this.props.defaultColDef ?? {
                                sortable: false,
                                filter: false,
                                floatingFilter: false,
                                enableRowGroup: true,
                                resizable: true,
                                suppressSizeToFit: false,
                                flex: 1
                            }}
                            handleRowSelected={this.handleRowSelected}
                            sideBar="none"
                        />
                    </div>
                </section>

                <section className="portfolio-ranking-grid">
                    <article className="portfolio-overview-section portfolio-overview-ranking-card">
                        <header className="portfolio-overview-section-header">
                            <div>
                                <h3>Top Gross Exposures</h3>
                            </div>
                        </header>
                        <div className="portfolio-overview-grid-shell">
                            <table className="portfolio-ranking-table">
                                <thead>
                                    <tr>
                                        <th>Deal</th>
                                        <th>Gross MV</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {topGrossExposures.map(row =>
                                        <tr key={row.deal}>
                                            <td>{row.deal}</td>
                                            <td>{this.agValueFormatter(row.value, 'millionsFormat')}</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </article>
                    <article className="portfolio-overview-section portfolio-overview-ranking-card">
                        <header className="portfolio-overview-section-header">
                            <div>
                                <h3>Top TRS Exposures</h3>
                            </div>
                        </header>
                        <div className="portfolio-overview-grid-shell">
                            <table className="portfolio-ranking-table">
                                <thead>
                                    <tr>
                                        <th>Deal</th>
                                        <th>TRS</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {topTrsExposures.map(row =>
                                        <tr key={row.deal}>
                                            <td>{row.deal}</td>
                                            <td>{this.agValueFormatter(row.value, 'millionsFormat')}</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </article>
                </section>
            </div>
        );
    }

    getLegacyTemplate() {
        if (this.props.GroupBy && this.props.gridData.length > 0) {
            var l = this.getData();
            const legacyMaturityChart = this.getBucketChartConfig('maturity bucket');
            const legacyVintageChart = this.getBucketChartConfig('vintage year');
            return (
                <div style={{ height: '100%', width: '100%', paddingTop: '15px', paddingBottom: '15px'}}>
                    <div>
                        <div className="flexDisplay" style = {{marginBottom: '25px'}}>
                            <div className="flexAuto centerElem">
                                <h3 style = {{color: "gray",margin: "0"}}>Gross MV</h3>
                                <h3 style = {{margin: "0"}}>{`$${this.agValueFormatter(l[0], 'millionsFormat')}M`}</h3>
                            </div>

                            <div className="flexAuto centerElem">
                                <h3 style = {{color: "gray", margin: "0"}}>Capital</h3>
                                <h3 style = {{margin: "0"}}>{`$${this.agValueFormatter(l[1], 'millionsFormat')}M`}</h3>
                            </div>

                            <div className="flexAuto centerElem">
                                <h3 style = {{color: "gray", margin: "0"}}>Leverage</h3>
                                <h3 style = {{margin: "0"}}>{`${this.agValueFormatter(l[2], 'leverageFormat')}`}</h3>
                            </div>

                            <div className="flexAuto centerElem">
                                <h3 style = {{color: "gray", margin: "0"}}>Current Yield</h3>
                                <h3 style = {{margin: "0"}}>{`${this.agValueFormatter(l[3], 'percentFormat1')}%`}</h3>
                            </div>
                        </div>

                        <h3 style={{textAlign:'center'}}>{`Gross Asset MV by ${this.props.GroupByName}`}</h3>

                        <div className="flexDisplay" style = {{marginBottom: '25px'}}>
                            <div style = {{width: '33%'}}>
                                <ChartDisplay
                                    chartTitle={''}
                                    chartType='pie'
                                    labelKey={this.props.GroupBy ? this.props.GroupBy : ''}
                                    angleKey="asset mv"
                                    dataList={this.props.gridData}
                                />
                            </div>
                            <div style = {{width: '33%'}}>
                                <ChartDisplay
                                    chartTitle={''}
                                    chartType='area-mln'
                                    GroupBy={this.props.GroupBy ? this.props.GroupBy : ''}
                                    xKey="format report date"
                                    yKeys="asset mv"
                                    dataList={this.state.chartData}
                                    rotationAngle={335}
                                />
                            </div>
                            <div style = {{width: '34%'}}>
                                <ChartDisplay
                                    chartTitle={''}
                                    chartType='area-normalized'
                                    GroupBy={this.props.GroupBy ? this.props.GroupBy : ''}
                                    xKey="format report date"
                                    yKeys="asset mv"
                                    dataList={this.state.chartData}
                                    rotationAngle={335}
                                />
                            </div>
                        </div>
                        <div className="flexDisplay" style = {{marginBottom: '25px'}}>
                            <div style = {{width: '33%'}}>
                                <ChartDisplay
                                    chartTitle="Historical Leverage"
                                    chartType='line-grouped-alt'
                                    xKey='format report date'
                                    fund={this.props.fund}
                                    sumKeys={['asset mv', 'mv total']}
                                    yName='Leverage'
                                    dataList={this.state.chartData}
                                    rotationAngle={335}
                                />
                            </div>
                            <div style = {{width: '33%'}}>
                                {this.renderBucketStackedChart('maturity bucket', legacyMaturityChart)}
                            </div>
                            <div style = {{width: '34%'}}>
                                {this.renderBucketStackedChart('vintage year', legacyVintageChart)}
                            </div>
                        </div>
                    </div>
                    <div>
                        <div style={{ height: '100%', width: '100%' }}>
                            <div style={{ height: '100%', width: '100%', marginBottom: '15px' }}>
                                <TorGrid
                                    guikey="portfolioOverviewSummary"
                                    isHideDateInputs={true}
                                    isHideSaveGridLayout={true}

                                    rowData={this.props.gridData}

                                    gridIdentityColumn="position_id"
                                    groupIncludeFooter={true}
                                    groupIncludeTotalFooter={true}
                                    suppressExpandablePivotGroups={true}
                                    className="dashboardgrid"
                                    rowGroupPanelShow="none"
                                    enableFilter={false}
                                    groupColumns={[this.props.GroupBy, 'deal']}
                                    domLayout="autoHeight"

                                    defaultColDef={this.props.defaultColDef ??
                                    {
                                        sortable: false
                                        , filter: false
                                        , floatingFilter: false
                                        , enableRowGroup: true
                                        , resizable: true
                                        , suppressSizeToFit: false
                                        , flex: 1
                                    }
                                    }

                                    handleRowSelected={this.handleRowSelected}
                                    sideBar='none'
                                />
                            </div>
                            <div style={{ height: '100%', width: '100%', marginBottom: "20px" }}>
                                <div style={{ gridTemplateColumns: '1fr 1fr', display: 'grid', height: '100%', width: '100%', position: 'relative' }}>
                                    <div style={{height: '70', margin: 'auto' }} >
                                        <TorGrid
                                            guikey="portfolioOverviewTopExposure"
                                            isHideDateInputs={true}
                                            isHideSaveGridLayout={true}

                                            AsOfDate='20200930'
                                            Frequency='m'
                                            gridIdentityColumn="position_id"

                                            rowData={this.props.gridData}
                                            groupBy='Deal'
                                            ignoreBlanks='asset mv'

                                            domLayout="autoHeight"


                                            suppressExpandablePivotGroups={true}
                                            className="dashboardTopGrid"
                                            rowGroupPanelShow="none"
                                            enableFilter={false}

                                            defaultColDef={this.props.defaultColDef ??
                                            {
                                                sortable: false
                                                , filter: false
                                                , floatingFilter: false
                                                , enableRowGroup: true
                                                , resizable: true
                                                , suppressSizeToFit: false
                                                , flex: 1
                                            }
                                            }

                                            handleRowSelected={this.handleRowSelected}
                                            sideBar='none'
                                            gridTitle='Top Gross Exposures'
                                            pagination={true}
                                        />
                                    </div>
                                    <div style={{height: '70', margin: 'auto' }}>
                                        <TorGrid
                                            guikey="portfolioOverviewTopTRS"
                                            isHideDateInputs={true}
                                            isHideSaveGridLayout={true}

                                            rowData={this.props.gridData}
                                            groupBy='Deal'
                                            ignoreBlanks='deal trs mv'

                                            AsOfDate='20200930'
                                            Frequency='m'
                                            gridIdentityColumn="position_id"
                                            domLayout="autoHeight"

                                            suppressExpandablePivotGroups={true}
                                            className="dashboardTopGrid"
                                            rowGroupPanelShow="none"
                                            enableFilter={false}

                                            defaultColDef={this.props.defaultColDef ??
                                            {
                                                sortable: false
                                                , filter: false
                                                , floatingFilter: false
                                                , enableRowGroup: true
                                                , resizable: true
                                                , suppressSizeToFit: false
                                                , flex: 1
                                            }
                                            }

                                            handleRowSelected={this.handleRowSelected}
                                            sideBar='none'
                                            gridTitle='Top TRS Exposures'

                                            pagination={true}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else {
            return null;
        }
    }
}
export default PortfolioOverview;